import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0015',
    ecrans: ['00-2'],
    params: ['id', 'itscleint', 'prucleint']
});
